
<p-dialog [(visible)]="showPreferenceForm" [draggable]="false" [modal]="true"
    [style]="{ width: '40%','height':'70vh'}">
    <ng-template #header class="dialogHeader">
        Create new column preference in {{title()}}
    </ng-template>
    <form class="column-preference-form " [formGroup]="columnForm">
      <div class="row">
        <div class=" col-md-6 mb-3">
          <label >Preference Name</label>
          <input type="text" class="form-control" formControlName="name" placeholder="Enter name here">
          <span class="error-validation"
            *ngIf="columnFormValue['name'].invalid && columnFormValue['name'].touched">
            Preference Name is required
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 mb-4">
          <label >Description</label>
           <textarea class="form-control" formControlName="description"   placeholder="type here" style="height: 60px"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="column-reorder-label mb-3">
            <p >Arrange Columns </p>
            <span>Select columns and drag to reorder</span>
          </div>
          <app-column-settings 
          (OnListUpdation)="OnListUpdation($event)"
          [sourceColumnList]="sourceColumnList" [targetColumnList]="targetColumnList" ></app-column-settings>
        </div>
      </div>
    </form>
    <ng-template #footer class="text-center">
        <div class="d-flex justify-content-center">
          <button (click)="savePreference()" [disabled]="columnForm.invalid || targetColumnList().length === 0" class="pn-button pn-button-primary pn-button-md me-2" type="submit">
            <span>{{ columnFormValue['id'].value ? 'Update' : 'Create' }}</span>
          </button>
          <button (click)="onCancel()" class="pn-button pn-button-tertiary pn-button-md">Cancel</button>
        </div>
    </ng-template>
</p-dialog>